export type ProjectStatus = 'DRAFT' | 'ACTIVE' | 'IN_PROGRESS' | 'SUBMITTED_FOR_GRADING' | 'COMPLETED';

export type StageStatus = {
  [key: string]: 'not_started' | 'in_progress' | 'completed';
};

export type TopicCandidate = {
  title: string;
  description?: string;
  investigation_direction?: string;
  materials_or_data?: string;
  risk_note?: string;
  syllabus_topic_anchor?: string;
  objective_texts?: string[];
  objective_ids?: string[];
};

export type ProjectArtifact = {
  id: string;
  stage: number;
  artifact_type: string;
  content: Record<string, unknown> | string;
  created_at?: string;
};

export type ProjectSource = {
  id: string;
  url: string;
  title?: string;
  snippet?: string;
  accessed_at?: string;
};

export type ClarificationOption = {
  id: string;
  title: string;
  subtitle?: string;
  topic?: string;
  subtopic?: string;
};

export type ClarificationPayload = {
  kind?: string;
  question: string;
  clarification_title?: string;
  clarification_subtitle?: string;
  other_option_label?: string;
  clarification_copy_variant_id?: string;
  options: ClarificationOption[];
};

export type Project = {
  id: string;
  student_id: string;
  subject_id: string;
  grade_level?: string;
  form?: string;

  title?: string;
  problem_statement?: string;
  current_stage: number;
  status: ProjectStatus;
  stage_status: StageStatus;

  topic_candidates?: TopicCandidate[];
  topic_selection_notes?: string;

  // Workspace data (populated on detail fetch)
  recent_artifacts?: ProjectArtifact[];
  workspace_artifacts?: ProjectArtifact[];
  workspace_version?: string;
  sources?: ProjectSource[];

  created_at?: string;
  updated_at?: string;
  last_activity_at?: string;
};

export type ProjectCreateInput = {
  student_id: string;
  subject_id: string;
  grade_level?: string;
  form?: string;
  title?: string;
  project_brief?: string;
};

export type ProjectChatInput = {
  message: string;
  allow_web_search?: boolean;
  thread_id?: string;
};

export type ProjectChatResponse = {
  answer: string;
  project: Project;
  clarification?: ClarificationPayload;
};

export type ProjectGradeInput = {
  submission_text: string;
  allow_web_search?: boolean;
};

export type ProjectRubricResult = {
  rubric_version: string;
  score_total: number;
  score_breakdown: Record<string, unknown>;
  strengths?: string;
  improvements?: string;
};

export type ProjectGradeResponse = {
  answer: string;
  rubric: ProjectRubricResult;
  project?: Project;
};

export type ProjectMessage = {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  metadata?: Record<string, unknown>;
  created_at?: string;
};

// Stage definitions (aligned with backend)
export const STAGE_NAMES: Record<number, string> = {
  1: 'Problem Identification',
  2: 'Investigation of Related Ideas',
  3: 'Generation of Possible Solutions',
  4: 'Selection of Best Solution',
  5: 'Development / Refinement',
  6: 'Presentation of Final Solution',
  7: 'Evaluation & Recommendations',
};

export const STAGE_MARKS: Record<number, number> = {
  1: 5,
  2: 10,
  3: 10,
  4: 5,
  5: 5,
  6: 10,
  7: 5,
};
